import store from './player-store';
import Api from '../clipboards/api';
import SelectClipboardModal from '../clipboards/select-clipboard-modal';
import EditModal from '../clipboards/edit-clipboard-modal';
import scribdAuthorize from '../scribd/scribd_oauth.js';
import { isDocument, isInfographic } from './presentation-types';

const SYSTEM_CLIPBOARD_TITLE = 'My Clips';
const MAX_TOP_CLIPS = 5;
const clipButton = $('.j-clips-button');
const slideshareObject = window.slideshare_object;
const utils = slideshareObject.utils;
const slideshow = slideshareObject.slideshow;
const clips = slideshow.clips || {};
const clipboards = slideshareObject.user.clipboards || [];
const clipCounts = slideshow.clip_counts || {};
let userClipsNumber = slideshareObject.user.clips_number || 0;
const storageKeys = {
  clippedOnce: 'slideshare.clips.clippedOnce.' + slideshareObject.user.id,
  defaultClipboard:
    'slideshare.clips.defaultClipboard.' + slideshareObject.user.id,
};

const clipsToolbar = $('.j-clips-toolbar');
const clipsInfo = $('.j-clips-info');
const clipsCount = $('.j-clips-count');
const slidePosition = $('.j-slide-position');
const clipButtonTop = $('.clip-button-top');
const clipRibbonContent = clipButtonTop.find('.ribbon-content');
const clipButtonAnchor = clipButtonTop.find('#clips-button-top');
const clippingIndicators = $('.clipping-indicator');

const getCurrentSlidePosition = () => {
  return store.index + 1;
};

const handleClipActionLoggedout = (e) => {
  e.preventDefault();
  e.stopPropagation();

  slideshareObject.addAfterLoginEvent({
    event: 'clip',
    data: {
      slideshow_id: slideshow.id,
      position: getCurrentSlidePosition(),
      tracking_id: slideshareObject.clippingTracker.trackingId,
    },
  });
  scribdAuthorize({
    from_source: slideshow.ss_url + '/' + store.index,
    slideshow_id: slideshow.id,
  });
};

const hasUserClippedOnce = () => {
  return (
    userClipsNumber ||
    !localStorage ||
    localStorage.getItem(storageKeys.clippedOnce)
  );
};

const createFakeSystemClipboard = () => {
  return {
    title: SYSTEM_CLIPBOARD_TITLE,
    private: false,
    system_created: true,
    is_default: true,
  };
};

const setUserClippedOnce = () => {
  if (localStorage) {
    localStorage.setItem(storageKeys.clippedOnce, true);
  }
};

const getUserDefaultClipboardId = () => {
  return (
    Number(
      localStorage && localStorage.getItem(storageKeys.defaultClipboard)
    ) || false
  );
};

const setUserDefaultClipboard = (clipboardId) => {
  if (localStorage) {
    localStorage.setItem(storageKeys.defaultClipboard, clipboardId);
  }
};

const getTopClips = () => {
  const clipsArray = Object.keys(clipCounts).map((key) => {
    return { position: key - 1, clipCount: clipCounts[key] };
  });

  const sorted = clipsArray.sort((a, b) => {
    if (a.clipCount !== b.clipCount) {
      return b.clipCount - a.clipCount;
    } else {
      return b.position - a.position;
    }
  });


  return sorted.slice(0, Math.min(MAX_TOP_CLIPS, sorted.length));
};

const getClipboards = () => {
  return Api.clipboards()
    .fail(function (xhr, status, error) {
      console.warn(
        slideshareObject.utils.i18n('clip.clips.error_fetching_clipboards') +
          ' ' +
          xhr.statusText
      );
    })
    .done(function (data) {
      const clipboards = data || [];

      // If no Clipboard exist for the current user,
      // Add a fake one (= without id). This Clipboard will eventually be
      // created later (when user will actually clip)
      if (clipboards.length === 0) {
        clipboards.push(createFakeSystemClipboard());
      } else {
        // Find the default clipboard and add a `is_default` property to the
        // default clipboard:
        // 1. Use the one stored in local storage
        // 2. Or, use the first system-generated clipboard in alpha order
        // 3. Or, use the first clipboard in alpha order
        // Note: we assume the backend
        // TODO: this should be done by the back-end at some point
        let defaultClipboard = null,
          defaultClipboardId = getUserDefaultClipboardId();

        clipboards.some(function (clipboard) {
          if (
            (defaultClipboardId && defaultClipboardId === clipboard.id) ||
            !defaultClipboard ||
            (!defaultClipboard.system_created && clipboard.system_created)
          ) {
            defaultClipboard = clipboard;

            // Stop iterating by returning `true` (cf `Array.prototype.some`),
            // if it's the user's default clipboard
            return defaultClipboardId && clipboard.id === defaultClipboardId;
          }
        });
        defaultClipboard.is_default = true;
        setUserDefaultClipboard(defaultClipboard.id);
      }

      return clipboards;
    });
};

const getDefaultClipboard = (clipboards) => {
  return clipboards.find((clipboard) => clipboard.is_default);
};

const createClipboard = (clipboard) => {
  return Api.createClipboard(clipboard).then(
    function (data) {
      clipboards.push(data.clipboard);
      return data.clipboard;
    },
    function (xhr) {
      console.warn(
        slideshareObject.utils.i18n('clip.clips.error_creating_clipboard') +
          ' ' +
          xhr.statusText
      );
    }
  );
};

const getCurrentClip = () => {
  return clips[store.index];
};

const roundClipsCount = (count, divisor, postFix) => {
  const formattedClipsCount = +(count / divisor).toFixed(1) + postFix;
  // Clip ribbon fits maximum four characters, rounding off when more than 4 characters in length
  if (formattedClipsCount.toString().length > 4) {
    return Math.floor(count / divisor) + postFix;
  } else {
    return +(count / divisor).toFixed(1) + postFix;
  }
};

const setClipsCountAndFontSize = (count) => {
  // when the clips count has 4 characters, make font-size 12px
  if (count.toString().length === 4) {
    clipsCount.addClass('decrease-clip-count-text-size');
  }
  clipsCount.text(count);
};

const formatClipsCount = function (count) {
  if (count >= 1e3 && count < 1e6) {
    return roundClipsCount(count, 1e3, 'K');
  } else if (count >= 1e6 && count < 1e9) {
    return roundClipsCount(count, 1e6, 'M');
  } else if (count >= 1e9 && count < 1e12) {
    return roundClipsCount(count, 1e9, 'B');
  } else {
    return count;
  }
};

const addClipToClipboard = (clip, clipboard) => {
  // update the list of clipboards associated with the clip
  function updateClip(data) {
    const clip = getCurrentClip();
    if (clip) {
      clip.clipboards = clip.clipboards || [];
      if (clip.clipboards.indexOf(clipboard.id) === -1) {
        clip.clipboards.push(clipboard.id);
      }
    } else {
      data.clip.clipboards = [clipboard.id];
    }
  }

  return Api.addClipToClipboard(clipboard.id, clip).then(
    function (data) {
      updateClip(data);
      return {
        clip: data.clip,
        clipboard: clipboard,
      };
    },
    function (xhr, status, error) {
      console.warn(
        slideshareObject.utils.i18n('clip.clips.error_adding_to_clipboard') +
          ' ' +
          xhr.statusText
      );
    }
  );
};

const setClippedClassAndAnchorTitle = (alreadyInUsersClipboard, count) => {
  let clipButtonAnchorTitle = '';

  if (!count) {
    // slide was not clipped by any user - show the plus icon in the clip ribbon
    clipButtonAnchorTitle = slideshareObject.utils.i18n(
      'slideshow.clip_cta.clip_slide_title_first_person'
    );
  } else if (count === 1) {
    if (alreadyInUsersClipboard) {
      // number of clips is 1 & clipped by the current user - show check icon in the clip ribbon
      clipButtonAnchorTitle = slideshareObject.utils.i18n(
        'slideshow.clip_cta.clip_slide_title_first_slide_clipped'
      );
    } else {
      clipButtonAnchorTitle = slideshareObject.utils.i18n(
        'slideshow.clip_cta.clip_slide_title_multiple_people',
        { count: +count }
      );
      clipRibbonContent.addClass('with-clip-count');
      setClipsCountAndFontSize(formatClipsCount(count));
      clipsCount.attr('aria-label', count);
    }
  } else if (count > 1) {
    if (alreadyInUsersClipboard) {
      // User clipped slide - show check icon & count in the clip ribbon
      clipButtonAnchorTitle = slideshareObject.utils.i18n(
        'slideshow.clip_cta.clip_slide_title_you_and_more_people',
        { count: +count - 1 }
      );
    } else {
      // User has not clipped the slide - show plus icon & count in the clip ribbon
      clipButtonAnchorTitle = slideshareObject.utils.i18n(
        'slideshow.clip_cta.clip_slide_title_multiple_people',
        { count: +count }
      );
    }
    clipRibbonContent.addClass('with-clip-count');
    setClipsCountAndFontSize(formatClipsCount(count));
    clipsCount.attr('aria-label', count);
  }
  clipButtonAnchor.attr('title', clipButtonAnchorTitle);
};

const setClipData = (clip) => {
  clips[clip.position] = clip;
  clipCounts[clip.position] = (clipCounts[clip.position] || 0) + 1;
  userClipsNumber++;
};

export const updateClippingUI = () => {
  const position = getCurrentSlidePosition();
  const currentClip = clips[position];
  const count = parseInt(clipCounts[position], 10);

  let alreadyInUsersClipboard = false;

  //reset clip values in html
  clipButtonTop.removeClass('clipped');
  clipRibbonContent.removeClass('with-clip-count');
  clipsCount.removeClass('decrease-clip-count-text-size');
  clipsCount.text('');
  clipsCount.attr('');
  clipsInfo.toggleClass('j-clips-info-none', !clipCounts[position]);
  clipsToolbar.toggleClass('inactive', !clipCounts[position]);

  if (currentClip) {
    alreadyInUsersClipboard = clipboards.find(
      (elem) => elem.user_id === currentClip.user_id
    );
  }

  if (!!alreadyInUsersClipboard) {
    clipButtonTop.addClass('clipped');
  }

  setClippedClassAndAnchorTitle(!!alreadyInUsersClipboard, count);
  slidePosition.attr('aria-label', position);
};

const saveClip = (position) => {
  var clip = {
    slideshow_id: slideshow.id,
    user_id: slideshareObject.user.id,
    position,
  };

  // 1. Get Clipboards. We assume they are alpha sorted already
  return (
    getClipboards()
      // 2. Create the clipboard if it's a fake one (= without id)
      .then(function (clipboards) {
        const defaultClipboard = getDefaultClipboard(clipboards);
        return defaultClipboard && defaultClipboard.id
          ? defaultClipboard
          : createClipboard(defaultClipboard);
      })

      // 3. Add clip to the clipboard
      .then(function (clipboard) {
        return addClipToClipboard(clip, clipboard);
      })

      // 4. Update UI
      .then(function (data) {
        if (data.clip.alreadyInClipboard) {
          // Conflict error, clip already exists in clipboard
          // Show the select clipboard modal
          const selectModal = new SelectClipboardModal({
            el: '#select-clipboard-modal',
            defaultClipboard: data.clipboard,
            actionType: 'copy',
          });
          selectModal.open({ clip: data.clip });
        } else {
          if (!clips[data.clip.position]) {
            //only update clip data if this is a newly created clip
            setClipData(data.clip);
          }

          updateClippingUI();
        }
      })

      // Error handling
      .fail(function (xhr) {
        if (xhr) {
          console.error(
            slideshareObject.utils.i18n('clip.clips.error_clipping') +
              ' ' +
              xhr.statusText
          );
        }
      })
  );
};

const createClip = (position) => {
  saveClip(position).then(() => {
    updateClippingUI();
  });
};

const clipSlide = (position) => {
  const existingClip = clips[position];
  if (!existingClip && !hasUserClippedOnce()) {
    // First time clipper
    // Display a modal asking user for a clipboard title/description
    // Create a clip & clipboard even if the user cancels the modal
    setUserClippedOnce();
    const createModal = new EditModal({
      el: '#clipboard-create-modal',
      type: 'create',
      showFirstClipMessage: true,
      onClose: function (status, response) {
        createClip(position);
      },
    });
    createModal.open();
  } else {
    // Create the clip
    createClip(position);
  }
};

const bindEvents = () => {
  clipButton.on('click', function (e) {
    if (utils.isUserAuthenticated() && slideshow.allow_clips) {
      clipSlide(getCurrentSlidePosition());
      return;
    }

    handleClipActionLoggedout(e);
  });
};

const setTopClips = () => {
  if (isInfographic() || isDocument()) {
    store.clipping.topClips = [];
    return;
  }
  const topClips = getTopClips();
  store.clipping.topClips = topClips;

  topClips.forEach((topClip, i) => {
    $(clippingIndicators[topClip.position]).addClass('top-clip');
  });
};

export const initializeClipping = () => {
  store.clipping = {};
  bindEvents();
  updateClippingUI();
  setTopClips();
};
